

import { CommonTable } from "../common/common-list/table/Table";
import { KTCard } from "../../../../_metronic/helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../common/common-list/components/pagination/Pagination";
import { setId } from "../../../../redux/features/shared/sharedSlice";
import { RoomModal } from "./RoomModal";
import './style.scss';
import { UserListHeader } from "../common/common-list/components/header/UserListHeader";
import { getRooms } from "../../../../redux/features/room/_roomAction";
import { roomsColumns } from "../common/common-list/table/columns/_roomColumns";
import Loader from "../common/Loader";

const RoomsList = () => {
  const sharedActions = useSelector((state: any) => state.sharedActions);
  const dispatch: any = useDispatch();
  const data: any = useSelector((state: any) => state.roomList?.data)||[];
  const totalRecord  = useSelector((state: any) => state.roomList?.totalRecord);
  const isLoading  = useSelector((state: any) => state.roomList?.isLoading);
  useEffect(() => {
    dispatch(setId('Room'))
    dispatch(getRooms({ page: 1, limit: 10 }));
  }, [dispatch]);

  const handleClick = (page: number) => {
    dispatch(getRooms({ page: page, limit: 10 }));
  };


  return (
    <>
      <KTCard>
        <UserListHeader />
        { isLoading ? <Loader />:<CommonTable data={data} columns={roomsColumns} />}
        {sharedActions.roomDetailsModal && <RoomModal />}
        {totalRecord > 10 && <Pagination
          totalRecord={totalRecord}
          handleClick={handleClick}
        />}
      </KTCard>
    </>
  );
};

export { RoomsList };
